module.exports = __webpack_public_path__ + "img/icon_mall.5ec9e18a.png";